<template>
    <div  @click="down" class="downback">
        <img src="https://cdn.hotplaydl.com/static/img/logo.png" alt="" class="img">
        <div class="down-info">
            <div class="down">GamesToday</div>
            <div class="down">{{size}}MB</div>
        </div>
        <div class="downbtn">
            <van-button type="default" :icon="downimg" class="detailbtn" size="small "> Download </van-button>
        </div>
    </div>
</template>

<script>
import downMixin from '@/mixins/downMixin'
export default {
    mixins: [downMixin]
}
</script>

<style lang="scss" scoped>
.downback {
  background-color: rgba(74, 144, 226, 0.1);
  height: 58px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
    .img {
        width: 32px;
        height: 32px;
        display: block;
        margin: 10px;
    }   
    .down-info {
        height: 32px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .down {
            border: 0;
            color: #4A90E2;
            text-align: left;
            font-size: 12px;
            flex: 2;
        }
    }
    .downbtn {
        flex: 4;
        text-align: right;
        padding-right: 12px;
        .detailbtn {
            width: 100px;
            height: 28px;
            background-color: #4A90E2;
            border-radius: 4px;
            font-size: 12px;
            color: white;
            line-height: 28px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/downBack.vue